export default "__VITE_ASSET__1SGZrZrp__"